import clip from './clip';
const clipFromDom = ({ content, line, ellips, addonRef, wrapRef }) => {
    const wrapWitdth = wrapRef.offsetWidth;
    const addonWidth = addonRef ? addonRef.offsetWidth : 0;
    const fontStyle = window.getComputedStyle(wrapRef).fontStyle;
    const fontVariant = window.getComputedStyle(wrapRef).fontVariant;
    const fontWeight = window.getComputedStyle(wrapRef).fontWeight;
    const fontSize = window.getComputedStyle(wrapRef).fontSize;
    const lineHeight = window.getComputedStyle(wrapRef).lineHeight;
    const fontFamily = window.getComputedStyle(wrapRef).fontFamily;

    return clip({
        content,
        line,
        ellips,
        addonWidth,
        wrapWitdth,
        fontStyle,
        fontVariant,
        fontWeight,
        fontSize,
        lineHeight,
        fontFamily,
    });
};

export default clipFromDom;
